import React, { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FiltersLabel } from '../../../search/FiltersModal/Filters.styles';
import { PropertyTypeRadioButtonWrapper } from '../../../search/common/Dropdown.styles';
import { updateFilter, propertyTypeSelector } from '../../../reducers/filters';
import { FilterOptions } from '../../../reducers/filters.types';
import {
    PropertyTypeRadio,
    FilterWrapper
} from './SearchInitiationMobileModal.styles';
import { Radio } from '@blueprint/ui';

type PropertyTypeRadioOptions = {
    options: FilterOptions;
    onPropertyTypeChange: (evt: ChangeEvent<HTMLInputElement>) => void;
    propertyType: string | string[];
};

const PropertyTypeRadioButtons: FC<PropertyTypeRadioOptions> = ({
    options,
    onPropertyTypeChange,
    propertyType
}) => {
    return (
        <>
            {options?.map((option) => {
                const { label, value } = option;

                const idKey = `mobile_subheader_property_type_option${
                    value ? `_${value}` : '_all'
                }`;

                const hasSelectedThisPropertyType = propertyType === value;

                return (
                    <PropertyTypeRadio key={`${value}-${label}`}>
                        <Radio
                            key={`${value}-${label}`}
                            id={idKey}
                            data-testid={value}
                            name="propertyTypeOption"
                            label={label}
                            value={value}
                            checked={hasSelectedThisPropertyType}
                            onChange={onPropertyTypeChange}
                        />
                    </PropertyTypeRadio>
                );
            })}
        </>
    );
};

export const SelectPropertyType: FC = () => {
    const reduxDispatch = useDispatch();
    const {
        selectedValue: propertyTypeSelectedValue,
        options: propertyTypeOptions
    } = useSelector(propertyTypeSelector);

    const onPropertyTypeChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('propertyType', evt.currentTarget.value));
    };

    const propertyTypeLabel = 'Property type';

    return (
        <FilterWrapper>
            <FiltersLabel htmlFor="modal-property-type-filter">
                {propertyTypeLabel}
            </FiltersLabel>
            <PropertyTypeRadioButtonWrapper>
                <PropertyTypeRadioButtons
                    onPropertyTypeChange={onPropertyTypeChange}
                    propertyType={propertyTypeSelectedValue}
                    options={propertyTypeOptions}
                />
            </PropertyTypeRadioButtonWrapper>
        </FilterWrapper>
    );
};
